import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import './TauriNavTabs.css';

const TauriNavTabs = ({ visuals, onSelect }) => {
    const [activeKey, setActiveKey] = useState('0');
    const [selectedTitle, setSelectedTitle] = useState('Others');
    const [dropdownOpen, setDropdownOpen] = useState(false);

    // Handle tab selection
    const handleTabSelect = (index) => {
        setActiveKey(index.toString()); // Update activeKey to string type
        const selectedVisualTitle = index > 2 ? visuals[index].title : 'Others';
        setSelectedTitle(selectedVisualTitle);
        if (onSelect) {
            onSelect(index);
        }
    };

    // Toggle dropdown visibility
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    // Render visual tabs up to a maximum of 3
    const renderVisualTabs = () => {
        const visibleVisuals = visuals.slice(0, 3); // Get up to 3 visuals
        return visibleVisuals.map((visual, index) => (
            <Nav.Item key={index}>
                <Nav.Link
                    eventKey={index.toString()} // Set eventKey to string type
                    active={activeKey === index.toString()} // Check against activeKey
                    onSelect={() => handleTabSelect(index)}
                    className="nav-link"
                >
                    {visual.title}
                </Nav.Link>
            </Nav.Item>
        ));
    };

    // Render "Others" dropdown menu for remaining visuals
    const renderOthersDropdown = () => {
        const remainingVisuals = visuals.slice(3); // Get remaining visuals from index 3 onwards
        if (remainingVisuals.length === 0) return null; // No need for dropdown if no remaining visuals

        return (
            <Dropdown show={dropdownOpen} onToggle={toggleDropdown} alignRight>
                <Dropdown.Toggle eventKey={visuals.length - 1} active={dropdownOpen} onClick={toggleDropdown} className="dropdown-toggle">
                    {selectedTitle}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {remainingVisuals.map((visual, index) => (
                        <Dropdown.Item key={index} eventKey={index + 3} active={activeKey === (index + 3).toString()} onSelect={() => handleTabSelect(index + 3)}>
                            {visual.title}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    return (
        <Nav className="tauri-nav-tabs" variant="tabs" activeKey={activeKey} onSelect={handleTabSelect}>
            {renderVisualTabs()}
            {renderOthersDropdown()}
        </Nav>
    );
};

export default TauriNavTabs;
